import { NavLink } from "react-router-dom";
import classNames from "classnames";
import { APP_PATHS } from "../../../constants/paths";
import WalletNavItem from "../../Layout/DashboardHeader/MechanicMenu/NavItem/WalletNavItem/WalletNavItem";
import PreviousOrdersNavItem from "../../Layout/DashboardHeader/MechanicMenu/NavItem/PreviousOrdersNavItem/PreviousOrdersNavItem";
import Logout from "../../Layout/DashboardHeader/MechanicMenu/Logout/Logout";
import classes from "./SideMenu.module.css";

const SideMenu = () => {
  return (
    <aside className={classes["aside"]}>
      <h2 className={classes["aside__header"]}>حسابي</h2>
      <nav>
        <ul className={classes["aside__list"]}>
          <li className={classes["aside__list-item"]}>
            <NavLink
              to={APP_PATHS.WALLET.url}
              className={({ isActive }) =>
                isActive
                  ? classNames(
                      classes["aside__list-item-link"],
                      classes["aside__list-item-link--active"]
                    )
                  : classes["aside__list-item-link"]
              }
            >
              <WalletNavItem />
            </NavLink>
          </li>
          <li className={classes["aside__list-item"]}>
            <NavLink
              to={APP_PATHS.PREVIOUS_ORDERS.url}
              className={({ isActive }) =>
                isActive
                  ? classNames(
                      classes["aside__list-item-link"],
                      classes["aside__list-item-link--active"]
                    )
                  : classes["aside__list-item-link"]
              }
            >
              <PreviousOrdersNavItem />
            </NavLink>
          </li>
        </ul>
        <div className={classes["aside__logout-wrapper"]}>
          <Logout />
        </div>
      </nav>
    </aside>
  );
};

export default SideMenu;
